import { Download } from 'iconoir-react';
import React from 'react';
import { utils as XLSXUtils, writeFile } from 'xlsx';

const ExportDataButton = ({ data, filename = 'data' }) => {
  function handleExport() {
    const worksheet = XLSXUtils.json_to_sheet(data);
    const workbook = XLSXUtils.book_new();
    XLSXUtils.book_append_sheet(workbook, worksheet, 'Sheet1');
    writeFile(workbook, `${filename}.xlsx`);
  }

  return (
    <button
      onClick={handleExport}
      className='btn-secondary'
    >
      <Download strokeWidth={2} className='w-4 h-4' />
      <span>Export Data</span>
    </button>
  )
}

export default ExportDataButton
